import { CertificateType } from "./../flags/CertificateType"

export default interface IOrganizationVm {
    name: string
    id: string
    allowedCertificateTypes: CertificateType
}

export const empty = (enableIteration: boolean = true): IOrganizationVm => {
	return {
		name: "",
		id: "",
		allowedCertificateTypes: CertificateType.NotSet
	} as IOrganizationVm
}